import { useFeatureValue } from '@growthbook/growthbook-react'

export const useSportsbookSlugs = (slug) => {
  const sportsbookProvider = useFeatureValue('igp_sportsbook_provider')

  if (sportsbookProvider === 'kambi') {
    if (slug === 'my-bets') return '/my-bets/bethistory/'

    if (slug === 'bonus') return '/bonus/bethistory/active/rewards/'
  }

  return `/${slug}/`
}
